// import Validator from 'validator';
import isEmpty from "lodash/isEmpty";
import { createTextMask } from "redux-form-input-masks";

// Initializing important variables
const REQUIRED_MESSAGE = "Required";

/**
 * Validate all field inside form
 * @param values
 * @return {{errors: {}, isValid: boolean}}
 */
export const PartnerAgreementValidator = (values) => {
  const errors = {};

  try {
    if (isEmpty(values.legalName) || !values.legalName) {
      errors.legalName = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.telephone) || !values.telephone) {
      errors.telephone = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.address1) || !values.address1) {
      errors.address1 = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.city) || !values.city) {
      errors.city = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.stateWithCountry) || !values.stateWithCountry) {
      errors.stateWithCountry = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.zip) || !values.zip) {
      errors.zip = REQUIRED_MESSAGE;
    }
    else {
      if(values.zip && values.zip.length > 0 && values.zip.length < 5) {
        errors.zip = "Please complete the Zip code, must be 5 characters or 9.";
      }

      if(values.zip && values.zip.length > 5  && values.zip.length < 9) {
        errors.zip = "Please complete the zip code, must be 5 characters or 9.";
      }
    }



    if (isEmpty(values.firstName) || !values.firstName) {
      errors.firstName = REQUIRED_MESSAGE;
    }
    if (isEmpty(values.lastName) || !values.lastName) {
      errors.lastName = REQUIRED_MESSAGE;
    }
    if (
      (values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,100}$/i.test(values.email)) ||
      isEmpty(values.email) ||
      !values.email
    ) {
      errors.email = "Invalid email address";
    }
    if (isEmpty(values.title) || !values.title) {
      errors.title = REQUIRED_MESSAGE;
    }
    if (!isEmpty(values.title) && values.title.length > 50) {
      errors.title = "Must be 50 characters or less";
    }
    // if (isEmpty(values.signatureName) || !values.signatureName) {
    //   errors.signatureName = "The Name on the signature is required.";
    // }

    return errors;
  } catch (e) {
    console.log("Error validating the form.", e);
  }
};

// TODO: Validation Mask
export const phoneMask = createTextMask({
  pattern: "(999) 999-9999",
});

export const zipMask = createTextMask({
  pattern: "99999-9999",
});



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Agreement/agreementFormValidation.js